<template>
    <div class="component page-container">
        <!--<cookie-bar />-->
        <!--<cookie-configurator />-->
        <site-header />
        <slot />
    </div>
</template>

<script>
    import SiteHeader from './SiteHeader.vue';
    //  import CookieBar from './CookieBar.vue';
    //import CookieConfigurator from './CookieConfigurator.vue';

    export default {
        name: 'PageContainer',
        components: {
            /*CookieBar,
            CookieConfigurator,*/
            SiteHeader,
        },
        mounted() {
            this.$store.dispatch('updateCookieSettings', this.$cookies.get('cookieSettings'));
        },
        computed: {
            isCookieConfiguratorModalOpen() {
                return this.$store.getters.isCookieConfiguratorModalOpen;
            },
            cookieSettings() {
                return this.$store.getters.cookieSettings;
            },
        },
    };
</script>
